import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IToast } from 'ui/Toast/Toast';

interface ToastState {
  message: string;
  title: string;
  variant?: IToast.TVariant;
}

const initialState: ToastState = {
  message: '',
  title: '',
  variant: 'success',
};

const index = createSlice({
  name: 'error',
  initialState,
  reducers: {
    setErrorToast: (state, action: PayloadAction<ToastState>) => {
      state.message = action.payload.message;
      state.title = action.payload.title;
      state.variant = 'error';
    },
    setSuccessToast: (state, action: PayloadAction<ToastState>) => {
      state.message = action.payload.message;
      state.title = action.payload.title;
      state.variant = 'success';
    },
    setToast: (state, action: PayloadAction<ToastState>) => {
      state.message = action.payload.message;
      state.title = action.payload.title;
      state.variant = action.payload.variant;
    },
    clearToast: () => initialState,
  },
});

export const { setErrorToast, setSuccessToast, setToast, clearToast } = index.actions;
export default index.reducer;
